import { Injectable } from '@angular/core';
import { LockObjectHistory } from '@osos/shared/api';
import { LockObjectHistoryPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { LockObjectParserV1Service } from '../../parsers';
import { ParserFactory } from '../../services';

@Injectable()
export class LockHistoryService extends FactoryBase<
  LockObjectHistory,
  LockObjectHistoryPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: LockObjectParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(
    presenter: LockObjectHistoryPresenterModel,
  ): LockObjectHistory {
    const parser = this.getParser(
      LockObjectHistory,
      LockObjectHistoryPresenterModel,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: LockObjectHistory,
  ): LockObjectHistoryPresenterModel {
    const parser = this.getParser(
      LockObjectHistory,
      LockObjectHistoryPresenterModel,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
